<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-header-title">
      {{ header }}
    </div>
    <div class="dialog-header-cross" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close"/>
    </div>
  </div>
  <div class="dialog-form">
    <div class="confirm-class">
      <p class="label-title subHeader fs-18">
        {{ subHeader }}
      </p>
      <div *ngIf="user === 0">
        <div [formGroup]="userForm" class="row1">
          <div class="col4">
            <label class="label-title"
              >{{ 'REDEEM_LOYALTY.DIAL_CODE' | fallbackTranslate }}
            </label>
            <input
              class="wd-100 input"
              nzSize="large"
              placeholder="{{ 'REDEEM_LOYALTY.ENT_HERE' | fallbackTranslate }}"
              nz-input
              formControlName="dialCode"
            />
          </div>
          <div class="col3">
            <label class="label-title">
              {{ 'REDEEM_LOYALTY.CUST_MOB_NUM' | fallbackTranslate }}</label
            >
            <nz-input-group [nzSuffix]="suffixIconButton">
              <input
                class="wd-100 input"
                nzSize="large"
                placeholder="{{ 'REDEEM_LOYALTY.ENTER_NUM_HERE' | fallbackTranslate }}"
                nz-input
                formControlName="number"
              />
            </nz-input-group>
          </div>
        </div>
        <div class="m-l-15">
          <label class="label-title">{{
            'REDEEM_LOYALTY.ENTER_OTP' | fallbackTranslate
          }}</label>
          <custom-otp-input
            #ngOtpInput
            (onInputChange)="onOtpChange($event)"
            [config]="config"
          ></custom-otp-input>
        </div>
      </div>
      <div *ngIf="user === 1">
        <label class="label-title">{{ 'REDEEM_LOYALTY.CUST_NAME' | fallbackTranslate }}</label>
        <input
          class="wd-100 input"
          nzSize="large"
          placeholder="{{ 'REDEEM_LOYALTY.ENT_NAME_HERE' | fallbackTranslate }}"
          nz-input
          [(ngModel)]="name"
        />
      </div>
      <div class="loader-section" *ngIf="user === 2 && !isPayLoading">
        <div class="generating"></div>
        <p class="loader-text">{{ 'REDEEM_LOYALTY.GET_WALLET' | fallbackTranslate }}</p>
      </div>
      <div class="row1" *ngIf="user === 2 && isPayLoading">
        <div class="col1">
          <div class="payCard m-b-10">
            <div class="paySub fw-500 p-5">
              {{ 'REDEEM_LOYALTY.PAY_USING_UR_AVAL' | fallbackTranslate }}:
              <span class="fw-600"> {{ Currency }} {{ loyaltyAmt }} </span>
            </div>
            <div class="paySub fw-500 p-5">
              {{ 'REDEEM_LOYALTY.TOTAL_BILL' | fallbackTranslate }} :
              <span class="fw-600"> {{ Currency }} {{ data?.amount }} </span>
            </div>
          </div>
          <label class="label-title"
            >{{ 'REDEEM_LOYALTY.ENT_AMT_USED' | fallbackTranslate }}
            <i
              nz-icon
              nzType="info-circle"
              nzTheme="outline"
              nzTooltipTitle="{{'REDEEM_LOYALTY.YOU_CANT_FILL_THE_AMOUNT_GREATER' | fallbackTranslate}}"
              nzTooltipPlacement="bottomLeft"
              nz-tooltip
            ></i>
          </label>
          <input
            class="wd-100 input m-r-10"
            nzSize="large"
            placeholder="{{ 'REDEEM_LOYALTY.ENTER_AMT_HERE' | fallbackTranslate }}"
            nz-input
            [(ngModel)]="payValue"
          />
        </div>
      </div>
    </div>
    <div class="flex dialog-footer">
      <button
        *ngIf="user === 0"
        nz-button
        nzType="primary"
        nzSize="large"
        [nzLoading]="isLoading"
        (click)="nextClicked()"
        class="save"
        [disabled]="!enable"
      >
        {{ 'REDEEM_LOYALTY.NEXT' | fallbackTranslate }}
      </button>
      <button
        *ngIf="user === 1"
        nz-button
        nzType="primary"
        nzSize="large"
        [nzLoading]="isLoading"
        (click)="saveClicked()"
        class="save"
        [disabled]="name.length < 3"
      >
        {{ 'REDEEM_LOYALTY.SAVE' | fallbackTranslate }}
      </button>
      <button
        *ngIf="user === 2"
        nz-button
        nzType="primary"
        nzSize="large"
        [nzLoading]="isLoading"
        (click)="payViaLoyalty()"
        class="save"
        [disabled]="payValue > loyaltyAmt"
        [nzLoading]="isPaid"
      >
        {{ 'REDEEM_LOYALTY.PAY_NOW' | fallbackTranslate }}
      </button>
    </div>
  </div>
  <ng-template #suffixIconButton>
    <a (click)="sendOtp()">{{ otpText }}</a>
  </ng-template>
</div>
